import { Component } from '@angular/core';
import { ICellEditorAngularComp } from 'ag-grid-angular';
import { FormsModule } from '@angular/forms';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';

@Component({
  selector: 'cell-editor',
  standalone: true,
  imports: [ FormsModule, NzInputModule, NzButtonModule, NzIconModule ],
  templateUrl: './cell-editor.component.html',
  styleUrl: './cell-editor.component.scss'
})
export class CellEditorComponent implements ICellEditorAngularComp{

  value!: string;
  params: any;

  agInit(params: any): void {
    this.params = params;
    this.value = params.value;
  }

  getValue(): any {
    return this.value;
  }

  get saving(): boolean {
    return this.params?.data?._saving === true;
  }

  onEnter() {
    if (this.saving) return;
    this.params.stopEditing();
  }

  onEscape() {
    this.params.stopEditing(true);
  }
}
